export const getTestimonialsList = ({ testimonialsList: { testimonialsList } }) => {
  if (!testimonialsList) {
    return []
  }

  return testimonialsList?.filter((comment) => comment.comment_visible === 1)
}
